// extracted by mini-css-extract-plugin
export var container = "_3s-0";
export var error = "_3s-9";
export var label = "_3s-5";
export var light = "_3s-6";
export var md = "_3s-3";
export var sm = "_3s-2";
export var thin = "_3s-8";
export var thinBold = "_3s-7";
export var vertical = "_3s-4";
export var xs = "_3s-1";